import axios from "axios"
import { env } from '../constants'


/* The token of the administrator goes with every call */
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } })


/* LIST — every promo code with its state and the numbers of the platform */
export const list = data => {
    const uri = `${env.startpoint}/admin/promo/list`
    return axios.post(uri, data, auth()).then(response => response).catch(error => error.response)
}

/* GET — one code and every point which used it */
export const get = data => {
    const uri = `${env.startpoint}/admin/promo/get`
    return axios.post(uri, data, auth()).then(response => response).catch(error => error.response)
}

/* SAVE — a new code or a change of one */
export const save = data => {
    const uri = `${env.startpoint}/admin/promo/save`
    return axios.post(uri, data, auth()).then(response => response).catch(error => error.response)
}

/* STATUS — switch a code on or off */
export const status = data => {
    const uri = `${env.startpoint}/admin/promo/status`
    return axios.post(uri, data, auth()).then(response => response).catch(error => error.response)
}

/* REMOVE */
export const remove = data => {
    const uri = `${env.startpoint}/admin/promo/remove`
    return axios.post(uri, data, auth()).then(response => response).catch(error => error.response)
}
